import { GET_BUY_SOURCES_SUCCESS } from 'stash/actions/api/buySources';
import { GetBuySourcesSuccessAction } from 'stash/actions/api/buySources';
import { TransferPathCapability } from 'stash/types/models/Transaction';

function buyCapabilitiesReducer(
	state: TransferPathCapability[] = [],
	action: GetBuySourcesSuccessAction
) {
	switch (action.type) {
		case GET_BUY_SOURCES_SUCCESS:
			// Each response is a full snapshot, and the backend omits the key
			// rather than sending an empty list, so retaining the previous
			// capabilities would leave a stale link-bank prompt next to a bank
			// that has since finished linking.
			return action.response.capabilities ?? [];
		default:
			return state;
	}
}

export default buyCapabilitiesReducer;
